import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const DataCell = React.memo(({ cell, dollerSign, onOpenModal }) => {
  if (typeof cell === "object" && cell !== null) {
    const hasValidData =
      Object.keys(cell).length > 0 && "count" in cell && "percentage" in cell;

    if (!hasValidData) {
      return <td />;
    }

    const isZero = cell.count === 0 || cell.count === 0.0;

    return (
      <td>
        {isZero ? (
          <div className="d-flex justify-content-between flex-wrap">
            <span className="pe-1">
              {dollerSign}
              {cell.count}
            </span>
            <span>{cell.percentage}%</span>
          </div>
        ) : (
          <Link
            onClick={() => onOpenModal(cell)}
            className="d-flex justify-content-between flex-wrap"
          >
            <span className="pe-1">
              {dollerSign}
              {cell.count}
            </span>
            <span>{cell.percentage}%</span>
          </Link>
        )}
      </td>
    );
  }

  return <td>{cell || ""}</td>;
});

DataCell.propTypes = {
  cell: PropTypes.any,
  dollerSign: PropTypes.string,
  onOpenModal: PropTypes.func
};

DataCell.displayName = "DataCell";

export default DataCell;
